module.exports = __webpack_public_path__ + "img/poly-8.f85a951d.png";